const baseSchema = {
  type: "object",
  properties: {
    eventId: { type: "number" },
    name: { type: "string", minLength: 1 },
    backgroundKey: { type: "string" },
    templateData: {
      type: "object",
      properties: {
        size: {
          type: "object",
          properties: {
            width: { type: "number", minimum: 0 },
            height: { type: "number", minimum: 0 },
            unit: { type: "string", enum: ["in", "mm"] },
          },
          required: ["width", "height", "unit"],
        },
        hasBackground: { type: "boolean" },
        backgroundTransform: {
          type: "object",
          properties: {
            fit: { type: "string", enum: ["fit", "fill", "stretch"] },
          },
        },
        elements: {
          type: "array",
          items: {
            type: "object",
            properties: {
              id: { type: "string", minLength: 1 },
              type: {
                type: "string",
                enum: ["text", "field", "qr", "rectangle", "image"],
              },
              layer: { type: "string", enum: ["print", "stock"] },
              xPct: { type: "number", minimum: 0, maximum: 100 },
              yPct: { type: "number", minimum: 0, maximum: 100 },
              widthPct: { type: "number", minimum: 0, maximum: 100 },
              heightPct: { type: "number", minimum: 0, maximum: 100 },
              fieldKey: {
                type: "string",
                enum: [
                  "fullName",
                  "firstName",
                  "lastName",
                  "email",
                  "title",
                  "occupation",
                  "category",
                ],
              },
              text: { type: "string" },
              fontSize: { type: "number", minimum: 0 },
              color: {
                type: "string",
                pattern: "^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$",
              },
              align: { type: "string", enum: ["left", "center", "right"] },
              font: { type: "string" },
              fill: {
                type: "string",
                pattern: "^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$",
              },
            },
            required: [
              "id",
              "type",
              "layer",
              "xPct",
              "yPct",
              "widthPct",
              "heightPct",
            ],
          },
        },
      },
      required: ["size", "elements"],
    },
  },
  required: ["eventId", "name"],
};

export const createBadgeTemplateSchema = {
  body: {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      sourceBadgeId: { type: "number" },
    },
  },
};

export const getBadgeTemplateSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
};

export const getBadgeTemplatesSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const updateBadgeTemplateSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
  body: {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      isDefault: { type: "boolean" },
    },
    required: [],
  },
};

export const renderBadgeSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
  body: {
    type: "object",
    properties: {
      ticketId: { type: "number" },
      mode: { type: "string", enum: ["print", "preview"] },
    },
    required: ["ticketId"],
  },
};

export const deleteBadgeTemplateSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
};
